import { render, staticRenderFns } from "./FloorAreaKitchen.vue?vue&type=template&id=d5c0a6d4&"
import script from "./FloorAreaKitchen.vue?vue&type=script&lang=ts&"
export * from "./FloorAreaKitchen.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports